// extracted by mini-css-extract-plugin
module.exports = {"labelCheck":"filter-checkbox_labelCheck__1BbfK"};